// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 手机 / 平板：隐藏可视滚动条，保留滚动 */
@media (max-width: 1199px) {
  html,
  body,
  .app-layout,
  .app-layout * {
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  html::-webkit-scrollbar,
  body::-webkit-scrollbar,
  .app-layout *::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
    display: none !important;
    background: transparent !important;
  }
}

/* 主内容区不再被 min-height:100vh 撑到导航下面 */
.app-layout .ant-layout-content {
  min-height: 0 !important;
}

.app-layout--mobile .app-main {
  padding-bottom: calc(72px + env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
  min-height: 0;
}

.app-layout--mobile .content-wrapper {
  min-height: 0;
  padding-bottom: 12px;
}

.app-layout--mobile .content-wrapper--fill {
  padding: 0;
}

.app-layout--mobile .content-wrapper--fill > * {
  flex: 1;
  min-height: 0;
  min-width: 0;
}

.app-layout--phone .header-title {
  max-width: 34vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}

.app-layout--tablet .user-info-text {
  display: none;
}

/* 表格可横滑，不被卡片裁切 */
.app-layout--mobile .ant-table {
  overflow: visible;
}

.app-layout--mobile .ant-table-wrapper,
.app-layout--mobile .ant-table-container,
.app-layout--mobile .ant-table-content,
.app-layout--mobile .ant-table-body {
  max-width: 100%;
  overflow-x: auto !important;
  -webkit-overflow-scrolling: touch;
}

.app-layout--mobile .ant-table-content > table,
.app-layout--mobile .ant-table-body > table,
.app-layout--mobile .ant-table-header > table {
  min-width: max-content !important;
}

.app-layout--phone .ant-pagination {
  flex-wrap: wrap;
  row-gap: 8px;
  justify-content: center;
}

/* 表单全宽、按钮可换行 */
@media (max-width: 767px) {
  .ant-form-inline {
    display: flex !important;
    flex-direction: column;
    align-items: stretch;
  }

  .ant-form-inline .ant-form-item {
    width: 100%;
    margin-inline-end: 0 !important;
  }

  .ant-form-item .ant-select,
  .ant-form-item .ant-picker,
  .ant-form-item .ant-input-number,
  .ant-form-item .ant-input,
  .ant-form-item .ant-input-affix-wrapper,
  .ant-form-item .ant-input-textarea {
    width: 100% !important;
    max-width: 100%;
  }

  .ant-space {
    flex-wrap: wrap;
    max-width: 100%;
  }

  .ant-modal {
    width: calc(100vw - 16px) !important;
    max-width: calc(100vw - 16px) !important;
    margin: 8px auto !important;
    top: 12px;
    padding-bottom: 0;
  }

  .ant-modal-body {
    max-height: calc(100vh - 160px);
    overflow: auto;
  }

  .ant-drawer-content-wrapper {
    width: 100% !important;
    max-width: 100vw !important;
  }

  .ant-card-head-wrapper {
    flex-wrap: wrap;
    gap: 8px;
  }

  .ant-card-extra {
    margin-inline-start: 0 !important;
    padding-top: 4px;
  }

  .ant-tabs {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .ant-row > .ant-col-6,
  .ant-row > .ant-col-8,
  .ant-row > .ant-col-12,
  .ant-row > .ant-col-16,
  .ant-row > .ant-col-18 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .ant-descriptions-view table,
  .ant-descriptions-view tbody,
  .ant-descriptions-row {
    display: block;
    width: 100% !important;
  }

  .ant-descriptions-row > th,
  .ant-descriptions-row > td,
  .ant-descriptions-item-label,
  .ant-descriptions-item-content {
    display: block;
    width: 100% !important;
    box-sizing: border-box;
  }

  .content-wrapper {
    overflow-wrap: anywhere;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .ant-modal {
    max-width: calc(100vw - 32px) !important;
  }

  .ant-drawer-content-wrapper {
    max-width: min(720px, 100vw) !important;
  }

  .ant-row > .ant-col-6,
  .ant-row > .ant-col-8 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .ant-form-inline {
    flex-wrap: wrap;
    row-gap: 8px;
  }
}

/* 订单详情：翻页条进入文档流，避免盖住底部导航和表单 */
.app-layout--mobile .order-detail-scroll {
  max-height: none !important;
  overflow: visible !important;
}

.app-layout--mobile .order-detail-dock {
  position: static !important;
  right: auto !important;
  bottom: auto !important;
  margin-top: 12px;
  max-width: 100% !important;
  flex-direction: row !important;
  flex-wrap: wrap;
  align-items: center !important;
  justify-content: space-between;
  background: #fff;
  border-radius: 12px;
  padding: 8px;
}

.app-layout--phone .order-detail-dock .ant-typography {
  white-space: normal !important;
}

/* 门户配置：手机上下排列，平板左右但不截断 */
.portal-admin__split {
  min-width: 0;
}

.portal-admin__split > * {
  min-width: 0;
}

@media (max-width: 767px) {
  .portal-admin {
    height: auto !important;
    min-height: 0 !important;
    padding: 0 !important;
  }

  .portal-admin__split {
    flex-direction: column !important;
    overflow: visible !important;
  }

  .portal-admin__split > * {
    flex: none !important;
    width: 100% !important;
    min-height: 280px;
  }

  .portal-lang-grid {
    grid-template-columns: 1fr !important;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
  .portal-admin {
    height: auto !important;
    min-height: 0 !important;
  }

  .portal-admin__split {
    min-height: 560px;
  }
}

/* 珠宝结构库 */
.inlay-library-shell {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 280px);
  min-height: 480px;
}

.inlay-composer {
  width: 100%;
  min-width: 0;
}

.inlay-composer textarea {
  flex: 1;
  min-width: 0;
}

@media (max-width: 1199px) {
  .inlay-library-shell {
    height: auto;
    min-height: 0;
  }

  .inlay-thread {
    flex: none !important;
    max-height: 55vh;
    min-height: 220px;
  }
}

@media (max-width: 767px) {
  .inlay-composer {
    flex-wrap: wrap;
  }
}

/* 社媒工具条 */
@media (max-width: 767px) {
  .social-publish-toolbar {
    flex-wrap: wrap;
    align-items: flex-start;
  }
}

/* 客户沟通 */
.chat-page {
  min-width: 0;
}

.chat-list .ant-list-item-meta {
  min-width: 0;
  flex: 1;
}

.chat-list .ant-list-item-meta-content,
.chat-list .ant-list-item-meta-title {
  min-width: 0;
  overflow: hidden;
}

.chat-filters {
  flex-wrap: wrap;
}

.chat-page--tablet .chat-filters .ant-btn {
  flex: 1;
  padding-inline: 6px;
}

.chat-composer .ant-input {
  flex: 1 1 140px;
  min-width: 0;
}

.chat-persona .ant-segmented {
  max-width: 100%;
  overflow-x: auto;
}

.chat-page--phone .chat-thread__actions {
  width: 100%;
  justify-content: flex-start;
}
`, "",{"version":3,"sources":["webpack://./src/renderer/styles/staffResponsive.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE;;;;IAIE,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;;;IAGE,mBAAmB;IACnB,oBAAoB;IACpB,wBAAwB;IACxB,kCAAkC;EACpC;AACF;;AAEA,oCAAoC;AACpC;EACE,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;EAC7D,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,eAAe;EACf,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;;;EAGE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE;IACE,wBAAwB;IACxB,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,+BAA+B;EACjC;;EAEA;;;;;;IAME,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,wCAAwC;IACxC,2BAA2B;IAC3B,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;IAC/B,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;;;;IAKE,cAAc;IACd,eAAe;EACjB;;EAEA;;;IAGE,cAAc;IACd,sBAAsB;EACxB;;EAEA;;;;IAIE,cAAc;IACd,sBAAsB;IACtB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;;EAEA;IACE,uCAAuC;EACzC;;EAEA;;IAEE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,8BAA8B;AAC9B;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,8BAA8B;EAC9B,eAAe;EACf,8BAA8B;EAC9B,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;IACvB,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,UAAU;AACV;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA,SAAS;AACT;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,OAAO;AACT;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B","sourcesContent":["/* 手机 / 平板：隐藏可视滚动条，保留滚动 */\r\n@media (max-width: 1199px) {\r\n  html,\r\n  body,\r\n  .app-layout,\r\n  .app-layout * {\r\n    scrollbar-width: none;\r\n    -ms-overflow-style: none;\r\n  }\r\n\r\n  html::-webkit-scrollbar,\r\n  body::-webkit-scrollbar,\r\n  .app-layout *::-webkit-scrollbar {\r\n    width: 0 !important;\r\n    height: 0 !important;\r\n    display: none !important;\r\n    background: transparent !important;\r\n  }\r\n}\r\n\r\n/* 主内容区不再被 min-height:100vh 撑到导航下面 */\r\n.app-layout .ant-layout-content {\r\n  min-height: 0 !important;\r\n}\r\n\r\n.app-layout--mobile .app-main {\r\n  padding-bottom: calc(72px + env(safe-area-inset-bottom, 0px));\r\n  box-sizing: border-box;\r\n  min-height: 0;\r\n}\r\n\r\n.app-layout--mobile .content-wrapper {\r\n  min-height: 0;\r\n  padding-bottom: 12px;\r\n}\r\n\r\n.app-layout--mobile .content-wrapper--fill {\r\n  padding: 0;\r\n}\r\n\r\n.app-layout--mobile .content-wrapper--fill > * {\r\n  flex: 1;\r\n  min-height: 0;\r\n  min-width: 0;\r\n}\r\n\r\n.app-layout--phone .header-title {\r\n  max-width: 34vw;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n\r\n.app-layout--tablet .user-info-text {\r\n  display: none;\r\n}\r\n\r\n/* 表格可横滑，不被卡片裁切 */\r\n.app-layout--mobile .ant-table {\r\n  overflow: visible;\r\n}\r\n\r\n.app-layout--mobile .ant-table-wrapper,\r\n.app-layout--mobile .ant-table-container,\r\n.app-layout--mobile .ant-table-content,\r\n.app-layout--mobile .ant-table-body {\r\n  max-width: 100%;\r\n  overflow-x: auto !important;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.app-layout--mobile .ant-table-content > table,\r\n.app-layout--mobile .ant-table-body > table,\r\n.app-layout--mobile .ant-table-header > table {\r\n  min-width: max-content !important;\r\n}\r\n\r\n.app-layout--phone .ant-pagination {\r\n  flex-wrap: wrap;\r\n  row-gap: 8px;\r\n  justify-content: center;\r\n}\r\n\r\n/* 表单全宽、按钮可换行 */\r\n@media (max-width: 767px) {\r\n  .ant-form-inline {\r\n    display: flex !important;\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .ant-form-inline .ant-form-item {\r\n    width: 100%;\r\n    margin-inline-end: 0 !important;\r\n  }\r\n\r\n  .ant-form-item .ant-select,\r\n  .ant-form-item .ant-picker,\r\n  .ant-form-item .ant-input-number,\r\n  .ant-form-item .ant-input,\r\n  .ant-form-item .ant-input-affix-wrapper,\r\n  .ant-form-item .ant-input-textarea {\r\n    width: 100% !important;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .ant-space {\r\n    flex-wrap: wrap;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .ant-modal {\r\n    width: calc(100vw - 16px) !important;\r\n    max-width: calc(100vw - 16px) !important;\r\n    margin: 8px auto !important;\r\n    top: 12px;\r\n    padding-bottom: 0;\r\n  }\r\n\r\n  .ant-modal-body {\r\n    max-height: calc(100vh - 160px);\r\n    overflow: auto;\r\n  }\r\n\r\n  .ant-drawer-content-wrapper {\r\n    width: 100% !important;\r\n    max-width: 100vw !important;\r\n  }\r\n\r\n  .ant-card-head-wrapper {\r\n    flex-wrap: wrap;\r\n    gap: 8px;\r\n  }\r\n\r\n  .ant-card-extra {\r\n    margin-inline-start: 0 !important;\r\n    padding-top: 4px;\r\n  }\r\n\r\n  .ant-tabs {\r\n    padding-left: 0 !important;\r\n    padding-right: 0 !important;\r\n  }\r\n\r\n  .ant-row > .ant-col-6,\r\n  .ant-row > .ant-col-8,\r\n  .ant-row > .ant-col-12,\r\n  .ant-row > .ant-col-16,\r\n  .ant-row > .ant-col-18 {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .ant-descriptions-view table,\r\n  .ant-descriptions-view tbody,\r\n  .ant-descriptions-row {\r\n    display: block;\r\n    width: 100% !important;\r\n  }\r\n\r\n  .ant-descriptions-row > th,\r\n  .ant-descriptions-row > td,\r\n  .ant-descriptions-item-label,\r\n  .ant-descriptions-item-content {\r\n    display: block;\r\n    width: 100% !important;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  .content-wrapper {\r\n    overflow-wrap: anywhere;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1199px) {\r\n  .ant-modal {\r\n    max-width: calc(100vw - 32px) !important;\r\n  }\r\n\r\n  .ant-drawer-content-wrapper {\r\n    max-width: min(720px, 100vw) !important;\r\n  }\r\n\r\n  .ant-row > .ant-col-6,\r\n  .ant-row > .ant-col-8 {\r\n    flex: 0 0 50%;\r\n    max-width: 50%;\r\n  }\r\n\r\n  .ant-form-inline {\r\n    flex-wrap: wrap;\r\n    row-gap: 8px;\r\n  }\r\n}\r\n\r\n/* 订单详情：翻页条进入文档流，避免盖住底部导航和表单 */\r\n.app-layout--mobile .order-detail-scroll {\r\n  max-height: none !important;\r\n  overflow: visible !important;\r\n}\r\n\r\n.app-layout--mobile .order-detail-dock {\r\n  position: static !important;\r\n  right: auto !important;\r\n  bottom: auto !important;\r\n  margin-top: 12px;\r\n  max-width: 100% !important;\r\n  flex-direction: row !important;\r\n  flex-wrap: wrap;\r\n  align-items: center !important;\r\n  justify-content: space-between;\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  padding: 8px;\r\n}\r\n\r\n.app-layout--phone .order-detail-dock .ant-typography {\r\n  white-space: normal !important;\r\n}\r\n\r\n/* 门户配置：手机上下排列，平板左右但不截断 */\r\n.portal-admin__split {\r\n  min-width: 0;\r\n}\r\n\r\n.portal-admin__split > * {\r\n  min-width: 0;\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .portal-admin {\r\n    height: auto !important;\r\n    min-height: 0 !important;\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .portal-admin__split {\r\n    flex-direction: column !important;\r\n    overflow: visible !important;\r\n  }\r\n\r\n  .portal-admin__split > * {\r\n    flex: none !important;\r\n    width: 100% !important;\r\n    min-height: 280px;\r\n  }\r\n\r\n  .portal-lang-grid {\r\n    grid-template-columns: 1fr !important;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) and (max-width: 1199px) {\r\n  .portal-admin {\r\n    height: auto !important;\r\n    min-height: 0 !important;\r\n  }\r\n\r\n  .portal-admin__split {\r\n    min-height: 560px;\r\n  }\r\n}\r\n\r\n/* 珠宝结构库 */\r\n.inlay-library-shell {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: calc(100vh - 280px);\r\n  min-height: 480px;\r\n}\r\n\r\n.inlay-composer {\r\n  width: 100%;\r\n  min-width: 0;\r\n}\r\n\r\n.inlay-composer textarea {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n@media (max-width: 1199px) {\r\n  .inlay-library-shell {\r\n    height: auto;\r\n    min-height: 0;\r\n  }\r\n\r\n  .inlay-thread {\r\n    flex: none !important;\r\n    max-height: 55vh;\r\n    min-height: 220px;\r\n  }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n  .inlay-composer {\r\n    flex-wrap: wrap;\r\n  }\r\n}\r\n\r\n/* 社媒工具条 */\r\n@media (max-width: 767px) {\r\n  .social-publish-toolbar {\r\n    flex-wrap: wrap;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n\r\n/* 客户沟通 */\r\n.chat-page {\r\n  min-width: 0;\r\n}\r\n\r\n.chat-list .ant-list-item-meta {\r\n  min-width: 0;\r\n  flex: 1;\r\n}\r\n\r\n.chat-list .ant-list-item-meta-content,\r\n.chat-list .ant-list-item-meta-title {\r\n  min-width: 0;\r\n  overflow: hidden;\r\n}\r\n\r\n.chat-filters {\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.chat-page--tablet .chat-filters .ant-btn {\r\n  flex: 1;\r\n  padding-inline: 6px;\r\n}\r\n\r\n.chat-composer .ant-input {\r\n  flex: 1 1 140px;\r\n  min-width: 0;\r\n}\r\n\r\n.chat-persona .ant-segmented {\r\n  max-width: 100%;\r\n  overflow-x: auto;\r\n}\r\n\r\n.chat-page--phone .chat-thread__actions {\r\n  width: 100%;\r\n  justify-content: flex-start;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
